import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`This route is Cait only and pretty luck based. Do not run this unless you're going for really top times!`}</p>
    </blockquote>
    <SEO title="Octopath Traveler Ophilia 3 Character Cait Primrose" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-shop"
      }}>{`Weapon Shop`}</h5>
      <ul>
        <li parentName="ul">{`Stone Rod`}</li>
        <li parentName="ul">{`Pointed Hat`}</li>
        <li parentName="ul">{`Linen Robe`}</li>
      </ul>
    </Menu>
    <p>{`Guide Summon Winds`}</p>
    <h4 {...{
      "id": "guardian-1924hp"
    }}>{`Guardian 1924HP`}</h4>
    <p>{`Summon, Holy Light x4 when Broken`}</p>
    <p>{`Allure Flurry, Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill Cait with Flurry`}</p>
    <p>{`Break Scholar Shrine battle with Flurry or Flee`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Reflective Veil, `}<strong parentName="li">{`Scholar`}</strong>{`: Blizzard, Lightning Blast`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`, loot `}<strong parentName="p">{`Purgation`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, Go to `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-shop-1"
      }}>{`Weapon Shop`}</h5>
      <p>{`Buy Round Shield`}</p>
    </Menu>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Light L`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Grandport`}</strong>{`. Pick Light S, `}<strong parentName="p">{`$1200`}</strong>{`. Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`. Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can maybe go Noblecourt here, buy Bracelet for safety. Extra Menu though.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`. Run to `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <p>{`Helgenish: Light M + Wind L`}</p>
    <p><strong parentName="p">{`Get Apothecary Shrine`}</strong>{`. Go to `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-2-start"
    }}>{`Chapter 2 Start`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Shadow M & L`}</strong>{`. Purchase `}<strong parentName="p">{`Wind M & Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{`, Guide Daniel.`}</p>
    <p>{`Kill battle outside with `}<strong parentName="p">{`Ice M`}</strong>{` + `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$3500`}</strong>{`.`}<br parentName="p"></br>{`
`}{`In Murkwood kill encounter with L Stone. Pick `}<strong parentName="p">{`Psychic Staff`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Merchant`}</strong>{`: Hired Help`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir-34969hp-sword-spear-ice-lightning-light"
    }}>{`Hrodvitnir 34969HP (Sword, Spear, Ice, Lightning, Light)`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: Attack`}</li>
      <li parentName="ul">{`Primrose: HHM x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Lightning Blast x3`}</li>
      <li parentName="ul">{`Tressa & Primrose: M/L Stone`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
      <li parentName="ul">{`Others: M/L Stone`}</li>
    </ul>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Bracelet`}</strong>{`, `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong><br parentName="p"></br>{`
`}{`After Guide, buy `}<strong parentName="p">{`Empowering Ring`}</strong>{`, `}<strong parentName="p">{`Pom M`}</strong>{` in church.`}<br parentName="p"></br>{`
`}{`After cutscenes `}<strong parentName="p">{`TP Grandport`}</strong>{`.`}</p>
    <p>{`Guide `}<strong parentName="p">{`Bombastic Boy`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Buy 1M & 2 L Stones`}</strong>{`, `}<strong parentName="p">{`Healing Grape Bunch & Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Pick `}<strong parentName="p">{`$25000`}</strong>{`, `}<strong parentName="p">{`Dazzling Artwork`}</strong>{`.`}</p>
    <p>{`If you haven't already, TP `}<strong parentName="p">{`Noblecourt`}</strong>{` and buy `}<strong parentName="p">{`Empowering Bracelet`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Unequip All, +Empowering Ring`}</li>
        <li parentName="ul">{`Tressa: +Bracelet`}</li>
        <li parentName="ul">{`Primrose: Optimize, +Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Apothecary`}</strong></li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal to full.`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "path-to-the-seaside-grotto"
    }}>{`Path to the Seaside Grotto`}</h3>
    <ul>
      <li parentName="ul">{`Azure Urchin: (1) 5611HP `}{`[Spear, Thunder, Light]`}</li>
      <li parentName="ul">{`Dark Curator: (3) 4790HP `}{`[Spear, Bow, Staff, Light]`}</li>
      <li parentName="ul">{`Flame Curator: (2) 4557HP `}{`[Spear, Bow, Staff, Ice]`}</li>
      <li parentName="ul">{`Scythe Crab: (3) 2484HP `}{`[Dagger, Axe, Wind]`}</li>
      <li parentName="ul">{`Mossy Tortoise: (4) 3808HP `}{`[Sword, Wind]`}</li>
    </ul>
    <p>{`S&Q inside Seaside Grotto.`}</p>
    <h4 {...{
      "id": "mystery-man--shady-figure-2817232197hp"
    }}>{`Mystery Man & Shady Figure (28172/32197HP)`}</h4>
    <p>{`You need an Inhibit by T3 or you lose.`}<br parentName="p"></br>{`
`}{`You need about 500 extra damage on SF, keep in mind he does Heal Wound T2.`}</p>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: HHB x2`}</li>
      <li parentName="ul">{`Primrose: Summon`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Axe x3`}</li>
      <li parentName="ul">{`Tressa: Pom M Self / Nothing / L Stone for safety strat.`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Attack x4 SF`}</li>
      <li parentName="ul">{`Ophilia: L Stone`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
    </ul>
    <h4 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h4>
    <ul>
      <li parentName="ul">{`M Stone if needed`}</li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{` if you used a M Stone.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to `}<strong parentName="p">{`Whispermill`}</strong>{`. Pick `}<strong parentName="p">{`Grape M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Apothecary`}</strong>{`: 3 Skills, `}<strong parentName="li">{`Scholar`}</strong>{`: Blizzard`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Apothecary`}</strong>{`: 3 Skills, `}<strong parentName="li">{`Merchant`}</strong></li>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Apothecary`}</strong>{`, 3 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`All: H&H`}</li>
      </ul>
      <h5 {...{
        "id": "healing-1"
      }}>{`Healing`}</h5>
      <p>{`Heal to full.`}</p>
    </Menu>
    <p>{`Break Plains Drake battle with Summons. Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`. Heal if damaged.`}</p>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Everything till $88500`}</li>
      </ul>
    </Menu>
    <p>{`S&Q in second screen. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <p>{`Break with HHM x4, kill with 1 L Stone + 2 M Stone`}</p>
    <h4 {...{
      "id": "mattias-97686hp"
    }}>{`Mattias 97686HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Typically you need 3 Max Vets with Inhibit, 1 3x Vets with Inhibit, and 1 Reflective Veil. Can make do with less if you have Stones. Typically, 1L 1M Stone makes up the damage from 1 HHVx4 without Inhibit.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`YOU WILL ALMOST ALWAYS NEED 2 Inhibits for this fight. Good fights are 5/6T, can extend to 9. After 9 he summons adds and you can't win.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Figuring out variations are an exercise left to the reader. I'm just going to put a standard fight up to T5.`}<br parentName="p"></br>{`
`}{`There are bonus strats available if you have someone before Mattias T2. Typically you heal someone with Grape M T1. Then Ophilia can afford to Defend T2 instead of Reflective, which gives you a chance to get Inhibit at the start of T3. > Start of T3 Inhibit is the most optimal Inhibit, can do fight with only 1 Inhibit.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: Blizzard`}</li>
      <li parentName="ul">{`Primrose: Summon`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Axe x2`}</li>
      <li parentName="ul">{`Tressa: Grape M`}</li>
      <li parentName="ul">{`Primrose: Pom M Tressa?`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Reflective Veil`}</li>
      <li parentName="ul">{`Primrose: HHV x4`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Assuming 2 Inhibit, or T3 Inhibit`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: Blizzard`}</li>
      <li parentName="ul">{`Primrose: Summon / Pom / Grape Bunch`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Axe x4`}</li>
      <li parentName="ul">{`More vets and stuff`}</li>
    </ul>
    <p>{`2 Cutscene then GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      